import { filterMap, selectPlaygroundFloor } from 'containers/Playground/playgroundSlice'
import { selectPlaceFilters, addFilters } from 'containers/MapDetails/placeSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import usePlaceMapParams from './usePlaceMapParams'
import { useHistory } from 'react-router-dom'
import UnavailablePopupContext from '../UnavailablePopupContext'
import React, { useContext } from 'react'

const usePlaceFilters = () => {
  const mapId = useReduxSelector(selectPlaygroundFloor)
  const filters = useReduxSelector(selectPlaceFilters)
  const { placeId, id } = usePlaceMapParams()
  const openUnavailablePopup = useContext(UnavailablePopupContext)

  const { replace, push, goBack } = useHistory()
  const dispatch = useReduxDispatch()
  const setFilters: React.Dispatch<React.SetStateAction<basic.Form>> = getState => {
    const state = typeof getState === 'function' ? getState(filters) : getState
    dispatch(addFilters({ filters: state }))
    dispatch(filterMap({ filters: state, mapId })).then(res => {
      if (res.meta.requestStatus === 'fulfilled' && (res.payload as playground.Map)?.objects?.warehouses) {
        const warehouseId = findAvailableWarehouseId((res.payload as playground.Map)!.objects!.warehouses!)
        if (warehouseId) {
          const action = id ? replace : push
          action(`/placemap/${placeId}/${warehouseId}`)
        } else {
          if (id) goBack()
          openUnavailablePopup?.()
        }
      }
    })
  }

  return [
    filters,
    setFilters
  ] as const
}

export const findAvailableWarehouseId = (warehouses: playground.Warehouse[]): string | undefined => {
  for (const warehouse of warehouses) {
    if (!warehouse.children &&
      warehouse?.warehouseData?.status?.isAvailableForRent &&
      !warehouse?.warehouseData?.status?.inTemporaryReservation &&
      !warehouse?.color_state?.includes('muted')) {
      return warehouse.typeId

    } else if (warehouse.children) {
      const foundId = findAvailableWarehouseId(warehouse.children)
      if (foundId) {
        return foundId
      }
    }
  }
}

export default usePlaceFilters